import Vue from 'vue';

// Find string in a given array of objects
Vue.filter('findProp', (array, prop, key, findValue) => {
    if (!array) return '';

    const found = array.find(item => item[prop] == findValue);

    if (found) {
        return found[key];
    }

    return '';
});

Vue.filter('capitalize', (value) => {
    if (!value) return '';
    value = value.toString();

    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('uppercase', (value) => {
    if (!value) return '';
    value = value.toString();

    return value.toUpperCase();
});

Vue.filter('number', (value, decimalPlaces = 0) => {
    if (value === null || value === undefined || value === '') return null;
    if (Number(value) == 'NaN') return 'NaN';
    const toNumber = Number(value).toFixed(decimalPlaces);
    return Number(toNumber).toLocaleString();
});

Vue.filter('currency', (value, decimalPlaces = 0) => {
    if (value === null || value === undefined || value === '') return null;
    if (Number(value) == 'NaN') return 'NaN';

    const toNumber = Number(value).toFixed(decimalPlaces);
    const options = {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    };

    return `${Number(toNumber).toLocaleString(undefined, options)}`;
});

Vue.filter('units', (value, unit) => {
    if (value === null || value === undefined || value === '') return null;

    return `${value} ${unit}`;
});

Vue.filter('date', (value) => {
    if (value === null || value === undefined || value === '') return null;
    const date = new Date(value);
    const lessThan2Digits = (n) => n < 10 ? '0' + n : n;
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();

    return `${lessThan2Digits(dd)}-${lessThan2Digits(mm)}-${yyyy}`;
});

Vue.filter('objectToCsv', (obj, keys) => {
    const array = keys.map(key => obj[key]).filter(item => !!item);
    if (array.length == 0) return '';

    return array.join(', ');
});

Vue.filter('mugReplace', (str, search) => {
    if (!str) return '';
    let string = str.replaceAll(search, 'My Utility Genius');
    const energyKeyword = search.split(' Energy');

    if (energyKeyword.length > 1) {
        return string.replaceAll(energyKeyword[0], 'My Utility Genius');
    }

    return string;
});

Vue.filter('maskMpan', (str, keys) => {
    if (str) {
        return `********${str.substring(8, 21)}`;
    }

    return str;
});

Vue.filter('maskMprn', (str) => {
    if (str) {
        return `**${str.substring(2, 7)}***`;
    }

    return str;
});